import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-168d7e6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tri-quick" }
const _hoisted_2 = { class: "tri-quick__menu" }
const _hoisted_3 = { class: "name" }

import type { RouteRecordRaw } from 'vue-router'
import { MenuLink } from '@tri-admin/layout'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShortcutMenu',
  props: {
    data: {},
    active: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "tri-quick__item",
          key: index
        }, [
          _createVNode(_unref(MenuLink), {
            class: "tri-quick__hand",
            to: item.path
          }, {
            default: _withCtx(() => [
              (item.meta?.icon)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon), {
                    key: 0,
                    size: "",
                    class: "icon",
                    color: ""
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_3, _toDisplayString(item.meta?.title || ''), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ])
  ]))
}
}

})